import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { API_BASE_URL } from '../env';

export default function AuthGoogleRedirect() {
  const [params] = useSearchParams();

  useEffect(() => {
    const redirect = params.get('redirect') || window.location.origin;
    window.location.replace(
      `${API_BASE_URL}/auth/google?redirect=${encodeURIComponent(redirect)}`,
    );
  }, [params]);

  return <div>Redirecting to Google sign-in...</div>;
}
